import { IEndInfo } from '@src/slide/infrastructure/module/dependent/line-info/line-base';
import BaseCurvedLine from '../line-curved-base';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';

class CurvedConnector4 extends BaseCurvedLine {
    public constructor() {
        super();
        this.defaultValue.controlValues = [0.5, 0.5];
    }
    public getControlPoints = (w: number, h: number) => {
        const controlValues = this.getControlValues();
        return [{
            x: w * controlValues[0],
            y: h * controlValues[1] / 2,
        }, {
            x: w * (1 + controlValues[0]) / 2,
            y: h * controlValues[1],
        }];
    };
    public svgPathInRect = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        const connectPoints = [
            {
                x,
                y,
            },
            {
                x: x + (w * controlValues[0]),
                y: y + (h * controlValues[1] / 2),
            },
            {
                x: x + (w * (controlValues[0] + 1) / 2),
                y: y + (h * controlValues[1]),
            },
            {
                x: x + w,
                y: y + h,
            },
        ];
        const bentPoints = [
            {
                x: x + (w * controlValues[0]),
                y,
            }, {
                x: x + (w * controlValues[0]),
                y: y + (h * controlValues[1]),
            }, {
                x: x + w,
                y: y + (h * controlValues[1]),
            },
        ];
        const clockwise: number[] = [];
        for (let i = 0; i + 1 < connectPoints.length; i++) {
            const dir = Graphic.pointToSegment(bentPoints[i], { p1: connectPoints[i], p2: connectPoints[i + 1] });
            clockwise.push(dir >= 0 ? 0 : 1);
        }
        const startCrossAngle = this.crossAngle(
            endInfo.head,
            w * Math.abs(controlValues[0]), h * Math.abs(controlValues[1]) / 2,
        );
        const startPos = this.getStartPos(startCrossAngle, connectPoints[0], connectPoints[1], clockwise[0]);
        const endCrossAngle = this.crossAngle(
            endInfo.tail,
            h * Math.abs(1 - controlValues[1]), w * Math.abs(1 - controlValues[0]) / 2,
        );
        const endPos = this.getEndPos(endCrossAngle, connectPoints[2], connectPoints[3], clockwise[2]);
        return `M${startPos.x} ${startPos.y} `
            + `A${w * controlValues[0]} ${h * controlValues[1] / 2},0 0 ${clockwise[0] > 0 ? 1 : 0} ${x + (w * controlValues[0])} ${y + (h * controlValues[1] / 2)} `
            + `A${w * (1 - controlValues[0]) / 2} ${h * controlValues[1] / 2},0 0 ${clockwise[1] > 0 ? 1 : 0} ${x + (w * (controlValues[0] + 1) / 2)} ${y + (h * controlValues[1])} `
            + `A${w * (1 - controlValues[0]) / 2} ${h * (1 - controlValues[1])},0 0 ${clockwise[2] > 0 ? 1 : 0} ${endPos.x} ${endPos.y}`;
    };
    public setLineInfo = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        const connectPoints = [
            {
                x,
                y,
            },
            {
                x: x + (w * controlValues[0]),
                y: y + (h * controlValues[1] / 2),
            },
            {
                x: x + (w * (controlValues[0] + 1) / 2),
                y: y + (h * controlValues[1]),
            },
            {
                x: x + w,
                y: y + h,
            },
        ];
        const bentPoints = [
            {
                x: x + (w * controlValues[0]),
                y,
            }, {
                x: x + (w * controlValues[0]),
                y: y + (h * controlValues[1]),
            }, {
                x: x + w,
                y: y + (h * controlValues[1]),
            },
        ];
        const clockwise: number[] = [];
        for (let i = 0; i + 1 < connectPoints.length; i++) {
            const dir = Graphic.pointToSegment(bentPoints[i], { p1: connectPoints[i], p2: connectPoints[i + 1] });
            clockwise.push(dir >= 0 ? 0 : 1);
        }
        const startCrossAngle = this.crossAngle(
            endInfo.head,
            w * Math.abs(controlValues[0]), h * Math.abs(controlValues[1]) / 2,
        );
        this.startPos = this.getStartPos(startCrossAngle, connectPoints[0], connectPoints[1], clockwise[0]);
        const endCrossAngle = this.crossAngle(
            endInfo.tail,
            h * Math.abs(1 - controlValues[1]), w * Math.abs(1 - controlValues[0]) / 2,
        );
        this.endPos = this.getEndPos(endCrossAngle, connectPoints[2], connectPoints[3], clockwise[2]);
    };
}

export default CurvedConnector4;
